module.exports = __webpack_public_path__ + "static/img/icon-search.3a863c9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-search.gif
// module id = AZdz
// module chunks = 1